import { api } from './api'
import { Pregnancy, MaternityVisit, PregnancyFormData, MaternityVisitFormData, PregnancyOutcome, DeliveryMethod, DeliveryLocation, BabyRecord } from '../types/maternity'

export const maternityService = {
  // Pregnancies
  getPregnancies: async (patientId: string): Promise<Pregnancy[]> => {
    const response = await api.get<Pregnancy[]>(`/pregnancies?patientId=${patientId}`)
    return response.data
  },

  getPregnancy: async (pregnancyId: string, patientId: string): Promise<Pregnancy> => {
    const response = await api.get<Pregnancy>(`/pregnancies/${pregnancyId}?patientId=${patientId}`)
    return response.data
  },

  createPregnancy: async (data: PregnancyFormData): Promise<Pregnancy> => {
    const response = await api.post<Pregnancy>('/pregnancies', data)
    return response.data
  },

  updatePregnancy: async (pregnancyId: string, patientId: string, data: Partial<PregnancyFormData>): Promise<Pregnancy> => {
    const response = await api.put<Pregnancy>(`/pregnancies/${pregnancyId}?patientId=${patientId}`, data)
    return response.data
  },

  recordOutcome: async (pregnancyId: string, patientId: string, outcomeData: {
    outcome: PregnancyOutcome
    outcomeDate?: string
    deliveryMethod?: DeliveryMethod
    deliveryLocation?: DeliveryLocation
    babies?: BabyRecord[]
  }): Promise<Pregnancy> => {
    const response = await api.post<Pregnancy>(`/pregnancies/${pregnancyId}/outcome?patientId=${patientId}`, outcomeData)
    return response.data
  },

  // Visits
  getVisits: async (pregnancyId: string): Promise<MaternityVisit[]> => {
    const response = await api.get<MaternityVisit[]>(`/pregnancies/${pregnancyId}/visits`)
    return response.data
  },

  getVisit: async (visitId: string, pregnancyId: string): Promise<MaternityVisit> => {
    const response = await api.get<MaternityVisit>(`/maternity-visits/${visitId}?pregnancyId=${pregnancyId}`)
    return response.data
  },

  createVisit: async (data: MaternityVisitFormData): Promise<MaternityVisit> => {
    const response = await api.post<MaternityVisit>('/maternity-visits', data)
    return response.data
  },

  updateVisit: async (visitId: string, pregnancyId: string, data: Partial<MaternityVisitFormData>): Promise<MaternityVisit> => {
    const response = await api.put<MaternityVisit>(`/maternity-visits/${visitId}?pregnancyId=${pregnancyId}`, data)
    return response.data
  },

  // Claim Form
  generateClaimForm: async (pregnancyId: string, patientId: string): Promise<{ content: string; fileName: string; mimeType: string }> => {
    const response = await api.post<{ content: string; fileName: string; mimeType: string }>(
      `/pregnancies/${pregnancyId}/claim-form?patientId=${patientId}`
    )
    return response.data
  },
}
